import { ComponentType } from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import {
  faAward,
  faBell,
  faBullseye,
  faTasks,
  faDatabase,
  // faFile,
  // faHome,
} from '@fortawesome/free-solid-svg-icons';

import Onboarding from '../../App/Components/Onboarding';
import OnlineMetricsJobResult from '../../App/Components/Ranking/OnlineMetricsJobResult';
import RelevanceRanking from '../../App/Components/Ranking/RelevanceRanking';
import SimilarityRanking from '../../App/Components/Ranking/SimilarityRanking';
import Monitoring from '../../App/Components/Monitoring/Monitoring';
import AlarmDetails from '../../App/Components/AlarmPolicy/AlarmDetails';
import AlarmTabs from '../../App/Components/AlarmPolicy/AlarmTabs';

interface RouteType {
  link: string;
  exact?: boolean;
  redirect?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component?: ComponentType<any>;
  props?: Record<string, unknown>;
}

export interface TabRouteType extends RouteType {
  icon: IconDefinition;
  name: string;
}

export const tabRoutes: TabRouteType[] = [
  {
    icon: faBell,
    name: 'Alarm',
    link: '/alarm',
    component: AlarmTabs,
    props: {
      basePath: '/alarm',
    },
  },
  {
    icon: faBullseye,
    name: 'Recommendation',
    link: '/similarityRanking',
    component: SimilarityRanking,
  },
  {
    icon: faTasks,
    name: 'Anomaly Monitoring',
    link: '/anomalyMonitoring',
    component: Monitoring,
  },
  {
    icon: faAward,
    name: 'Triaging ',
    link: '/relevanceRanking',
    component: RelevanceRanking,
  },
  {
    icon: faDatabase,
    name: 'Onboarding',
    link: '/onboarding',
    component: Onboarding,
  },
];

const routes: RouteType[] = [
  {
    link: '/',
    exact: true,
    redirect: '/alarm',
  },
  // {
  //   link: '/changePassword',
  //   component: ComingSoon,
  // },
  {
    link: '/job/:id',
    component: OnlineMetricsJobResult,
  },
  {
    link: '/alarmDetails/:id',
    component: AlarmDetails,
  },
];

export const getRoutes = (): RouteType[] => [
  ...tabRoutes.map(({ link, exact, component, props }) => ({ link, exact, component, props })),
  ...routes,
];
